import { useMutation, useQuery } from '@tanstack/react-query';
import { publicCheckoutService, PublicCheckoutRequestError } from '@/services/public-checkout.service';
import type { PublicCheckoutData, PublicCheckoutResponse } from '@/types/public-checkout';

export const publicCheckoutKeys = {
  all: ['public-checkout'] as const,
  detail: (
    productId: string,
    params?: {
      planId?: string | null;
      cycleId?: string | null;
      priceId?: string | null;
      checkoutToken?: string | null;
      lang?: string | null;
    },
  ) => [...publicCheckoutKeys.all, productId, params] as const,
};

export function usePublicCheckout(
  productId: string | null | undefined,
  enabled = true,
  params?: {
    planId?: string | null;
    cycleId?: string | null;
    priceId?: string | null;
    checkoutToken?: string | null;
    lang?: string | null;
  },
) {
  return useQuery<PublicCheckoutData, PublicCheckoutRequestError>({
    queryKey: productId ? publicCheckoutKeys.detail(productId, params) : publicCheckoutKeys.all,
    queryFn: () => {
      if (!productId) {
        throw new PublicCheckoutRequestError('Missing product id');
      }
      return publicCheckoutService.getCheckout(productId, params);
    },
    enabled: enabled && Boolean(productId),
  });
}

export function useSubmitPublicCheckout() {
  return useMutation<PublicCheckoutResponse, PublicCheckoutRequestError, Parameters<typeof publicCheckoutService.submitCheckout>[0]>({
    mutationFn: (input) => publicCheckoutService.submitCheckout(input),
  });
}
